"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoPlayEpic = void 0;
var _reduxObservable = require("redux-observable");
var _types = require("./types");
var _types2 = require("../config/types");
var _operators = require("rxjs/operators");
var _types3 = require("../game/types");
var _rxjs = require("rxjs");
var _types4 = require("../ui/types");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AutoPlayEpic = exports.AutoPlayEpic = /*#__PURE__*/_createClass(function AutoPlayEpic() {
  var _this = this;
  _classCallCheck(this, AutoPlayEpic);
  _defineProperty(this, "getEpic", function () {
    return (0, _reduxObservable.combineEpics)(_this.autoPlayStopOnResize, _this.autoPlayCounter, _this.autoPlayEnd, _this.autoPlay, _this.autoPlayFreespins);
  });
  /**
   * Detect that the started round was an autoplay round, if so count.
   */
  _defineProperty(this, "autoPlayCounter", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.ROUND_START), (0, _operators.filter)(function (a) {
      return !store.value.blitz.on && store.value.autoPlay.roundsLeft > 0;
    }), (0, _operators.mapTo)({
      type: _types.AUTO_PLAY_ROUND_PLAYED
    }));
  });
  /** all rounds played. */
  _defineProperty(this, "autoPlayEnd", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.AUTO_PLAY_ROUND_PLAYED), (0, _operators.filter)(function (a) {
      return !store.value.blitz.on && store.value.autoPlay.roundsLeft == 0;
    }), (0, _operators.mapTo)({
      type: _types.AUTO_PLAY_STOP
    }));
  });
  /**
   * Stop Auto play on window resize.
   * @param action$
   * @param store
   */
  _defineProperty(this, "autoPlayStopOnResize", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.WINDOW_RESIZE), (0, _operators.filter)(function (a) {
      return store.value.autoPlay.on;
    }), (0, _operators.mapTo)({
      type: _types.AUTO_PLAY_STOP
    }));
  });
  /**
   * Start playing auto play and start the rounds.
   * @param action$
   * @param store
   */
  _defineProperty(this, "autoPlay", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.AUTO_PLAY, _types3.ROUND_END), (0, _operators.filter)(function (a) {
      return store.value.autoPlay.roundsLeft > 0 && !store.value.game.locked;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.of)({
        type: _types4.SPIN_BUTTON
      }).pipe((0, _operators.delay)(store.value.config.autoPlayTimeBetweenRounds), (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types.AUTO_PLAY_STOP))));
    }));
  });
  /**
   * Start playing auto play and start the rounds.
   * @param action$
   * @param store
   */
  _defineProperty(this, "autoPlayFreespins", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.AUTO_PLAY_FREE_SPIN_START), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types4.SPIN_BUTTON
      }), action$.pipe((0, _reduxObservable.ofType)(_types3.ROUND_END), (0, _operators.take)(1), (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types.AUTO_PLAY_STOP))), (0, _operators.mapTo)({
        type: _types.AUTO_PLAY_STOP
      })), action$.pipe((0, _reduxObservable.ofType)(_types3.SPIN_END), (0, _operators.mergeMap)(function () {
        return (0, _rxjs.of)({
          type: _types4.SPIN_BUTTON
        }).pipe((0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types.AUTO_PLAY_STOP))));
      })));
    }));
  });
});
//# sourceMappingURL=epics.js.map